import { useQuery } from '@tanstack/react-query'
import { getOperatorDepositTransactions } from '../../services'
import { GetOperatorDepositTransactionsRequest } from '../../../type'
import { BankQueryKeys } from '../../../keys'

export default function useQueryOperatorDepositTransactions(
	payload: GetOperatorDepositTransactionsRequest,
) {
	return useQuery({
		queryKey: [BankQueryKeys.GetOperatorDepositTransactions, payload],
		queryFn: () => getOperatorDepositTransactions(payload),
	})
}
